module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search_placeholder":"Search by typing building or street name","current_location":"Find my current location","fetching_location":"Finding your location...","location_error-1":"Please turn on location service","location_error-2":"Unable to get your location at the moment","location_error-3":"Unable to get your location at the moment","drag_help":"Adjust location by dragging the marker"},"ja":{"search_placeholder":"場所を検索","current_location":"現在位置を利用する","fetching_location":"現在位置取得中","location_error-1":"現在位置の許可が必要です","location_error-2":"現在位置を取得できなかった","location_error-3":"現在位置を取得できなかった","drag_help":"あなたは赤いマーカーを動かすことができます"}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/components/DeliveryLocationPicker.vue
// module id = 7CpP
// module chunks = 14